<template>
    <div class="page k-background">
        <div class="title">
            <h1>Stawiarska Stala</h1>
            <h2>Kancelaria Radców Prawnych</h2>
        </div>
        <img class="team" src="/assets/homepage-zespol.png">
        <div class="content">
            <div v-html="start.content" v-show="start">
                {{ start.content }}
            </div>
            <b-link class="more" :to="{ name: 'Specjalizacje' }">Specjalizacje <font-awesome-icon icon="arrow-right" :style="{ 'margin-left': '2rem', 'color': '#292a2b' }" /></b-link>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Start',
    beforeCreate() {
    if(this.$store.state.pages.length === 0) {
        this.$store.dispatch('getPages');
      }
  },
  computed: {
      start() {
          return this.$store.getters.getPage('/start');
      } 

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.content {
    background:#fff;
}
.k-background::before {
    display:block;
    background-image: url('/assets/homepage-tlo.jpg');
    background-size: cover; 
    background-repeat:no-repeat;
    background-position:bottom right;
    width:100%;
    height:100%;
    content:"";
    position:absolute;
    top:0;
    left:0;
    opacity:0.5;
    z-index:-2;
}

    @media (max-width:959px) {
        .k-background::before {
            height: 600px;
        }
        .k-background {
            margin-bottom:0px;
            padding-bottom:0px;
        }
    }
</style>
<style>
    .team {
        width:100%;
        max-width:400px;
        padding-top:2rem;
        margin:0 auto -3rem auto;
        display:block;
    }
    .title {
        text-align:center;
        text-transform: uppercase;
    }
    .title h1 {
        font-size: 3rem;
        text-transform: uppercase;
    }
    .title h2 {
        font-size: 2rem;
    }

    @media (min-width:340px) {
        .title h1 {
            font-size: calc(180% + 6 * (100vw - 340px) / 300)
        }
        
        .title h2 {
            font-size: calc(150% + 2 * (100vw - 340px) / 300)
        }
    }
    @media (min-width:960px) {
        .title::after {
            display:block;
            width:100%;
            content: "";
            border-bottom: .1rem solid #000;
            margin-top:20px;
        }
        .team {
            width:auto;
            max-width:50%;
            position: absolute;
            bottom:0;
            right:0;
            margin-bottom:0;
            max-height:65%;
        }
        .content {
            background: none !important;
            min-height:400px;
        }
        p.intro {
            font-size:1.8rem;
        }
        p.intro::after {
            border:none;
            margin-top:0;
        }
        p.k-wrap {
            width:50%;
        }
   
    }
</style>
<style scoped>
    @media (min-width:960px) {
        a.more {
            position:absolute;
            z-index:5;
            bottom:2rem;
            right:6rem;
            color:#fff;
        }
   
    }
</style>